import { PcmpDepartmentDivisionsTable } from '../components/PcmpDepartmentDivisions/PcmpDepartmentDivisionsTable';

export function PcmpDepartmentDivisionsPage() {
  return <PcmpDepartmentDivisionsTable />;
}
